module.exports = __webpack_public_path__ + "img/Group 6848@2x.59693739.png";